export const axiosConfig = {
  baseURL: process.env['VUE_APP_BASE_API'],
  timeout: 10000
}
